module.exports = __webpack_public_path__ + "img/emailConf.a6d62850.svg";